export const downloadConstants = {
  SET_XLS_LOADING: 'download/SET_XLS_LOADING',
  SET_XML_LOADING: 'download/SET_XML_LOADING',
  SET_QR_LOADING: 'download/SET_QR_LOADING',
  GET_EXPORTS: 'download/GET_EXPORTS',
  SET_EXPORTS: 'download/SET_EXPORTS',
  SET_EXPORTS_LOADING: 'download/SET_EXPORTS_LOADING',
  TRACK_EXPORT: 'download/TRACK_EXPORT',
  UPSERT_EXPORT: 'download/UPSERT_EXPORT',
  CANCEL_EXPORT: 'download/CANCEL_EXPORT',
  SET_DISMISSED_EXPORT_IDS: 'download/SET_DISMISSED_EXPORT_IDS',
  CLEAR_COMPLETED_EXPORTS: 'download/CLEAR_COMPLETED_EXPORTS',
  SET_EXPORT_QUEUE_OPEN: 'download/SET_EXPORT_QUEUE_OPEN',
  FETCH_EXPORTED_FILE: 'download/FETCH_EXPORTED_FILE',
  SET_DOWNLOADED_FILE: 'download/SET_DOWNLOADED_FILE',
  CLEAN_DOWNLOAD: 'download/CLEAN_DOWNLOAD',
  SET_ASYNC_EXPORT_RESULT: 'download/SET_ASYNC_EXPORT_RESULT',
  CONNECT_SOCKET: 'download/CONNECT_SOCKET',
};
